import React from "react";
import { styled, TextField, TextFieldProps } from "@material-ui/core";
const StyledTextField = styled(TextField)(({ theme }) => ({
  backgroundColor: "white",
  marginBottom: "4px",
  boxSizing: "border-box",
  "& .MuiOutlinedInput-root": {
    borderRadius: 12,
    border: "1px solid rgba(219, 223, 232, 0.6)",
    "&:hover": {
      boxShadow: "0px 4px 4px rgba(27, 27, 27, 0.1)",
      border: "1px solid #D7D7D7",
    },
  },
  "& label": {
    color: theme.palette.text.disabled,
    fontSize: `${theme.spacing(2)}px`,
  },
  [theme.breakpoints.up("sm")]: {
    "& label": {
      fontSize: "19px",
    },
  },
}));

const Input: React.FunctionComponent<TextFieldProps> = ({ ...props }) => {
  return <StyledTextField {...props} color="secondary" />;
};

export default Input;
